import React from 'react';

const Footer = () => {
  return (
    <footer id="footer" className="bg-transparent" style={{padding: '20px 0'}}>
      <div className="container-fluid">
        <div className="row">
          <div className="col-12 text-center">
            <p className="my-2">© 2025 <a href="#">Rovo Automation</a>. All Rights Reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
